module.exports = __webpack_public_path__ + "static/media/FACURRYP_MENU-normal.32eb2209.png";